import React, { useEffect, useState } from "react";
import { Paper, Button, Box } from "@mui/material";
import SearchTopBar from "./SearchTopBar";
import ConditionList from "./ConditionList";
import { useAMGSelectedContext } from "../../../Context/GlobalContext";

import CopyBox from "../../MessageBox/CopyBox";
import { useLanguageContext } from "../../../Context/LanguageContext";
import NotValidFieldColumn from "./NotValidFieldColumn";

const SearchBox_new = ({
  filterList,
  saveFilterList,
  conditions,
  setConditions,
  toggleFilter,
  reportCode,
  handleFilterOpertation,
  handleFiltersave,
  handleDelFilterSuccess,
  isShowSaveFilterDropDown,
  showSaveButton,
}) => {
  const { localization } = useLanguageContext();
  const [messageBoxText, setMessageBoxText] = useState({});
  const [dialogboxOpen, setdialogOpen] = useState(false);
  const [msgButtons, setMsgButtons] = useState([]);
  const [copyAnzahl, setCopyAnzahl] = useState(null);
  const initialCondition = { Name: "", Operator: "", Value: "" };
  const [hasReset, setHasReset] = useState(false);

  const [notValidCol, setNotValidCol] = useState([]);

  useEffect(() => {
    if (
      filterList &&
      filterList.length > 0 &&
      conditions.length === 1 &&
      conditions[0].Name !== ""
    ) {
      const validFilterNames = filterList.map((filter) => filter.name);
      const notContainedList = [];
      conditions.forEach((element) => {
        if (!validFilterNames.includes(element.Name)) {
          notContainedList.push(element.Name);
        }
      });
      setNotValidCol(notContainedList);
    }
  }, []);

  useEffect(() => {
    if (conditions.length === 0) {
      setConditions([initialCondition]);
    }
  }, [conditions.length]);

  const handleConditionChange = (index, key, value) => {
    const newConditions = [...conditions];
    newConditions[index][key] =
      typeof value === "boolean" ? (value ? "true" : "false") : value;
    if (key === "Operator" && value === "#") {
      newConditions[index].Value = "empty";
    }

    if (key === "Name") {
      newConditions[index].Operator = "";
      newConditions[index].Value = "";
    }
    setConditions(newConditions);
  };

  const handleAddCondition = () => {
    setConditions([...conditions, initialCondition]);
  };

  const handleRemoveCondition = (index) => {
    const newConditions = conditions.filter((_, i) => i !== index);
    setConditions(newConditions);
  };

  const handleReset = () => {
    setConditions([{ Name: "", Operator: "", Value: "" }]);
    setHasReset(true);
  };

  const allConditionsFilled = () => {
    if (notValidCol.length > 0) {
      return false;
    }
    return conditions.some((condition) => {
      if (condition.Operator === "#") {
        return true;
      }

      if (typeof condition.Value === "string") {
        return condition.Value.trim() !== "";
      }

      return typeof condition.Value === "boolean";
    });
  };

  const handleSaveFilter = () => {
    setMessageBoxText({
      title: localization.enterfiltername,
      msg: "",
      anlageID: "",
    });

    setMsgButtons([
      {
        title: localization.cancelbutton,
        func: closeMsg,
        type: "cancel",
      },
      { title: localization.save, func: handleSaveFilterCallBack, type: "ok" },
    ]);
    setdialogOpen(true);
  };
  const closeMsg = () => {
    setdialogOpen(false);
  };

  function handleInput(filterName) {
    sessionStorage.setItem("filName", filterName);
    setCopyAnzahl(filterName);
  }

  function handleSaveFilterCallBack(fieldName) {
    handleFiltersave(fieldName);
    setdialogOpen(false);
  }

  function handleSave() {
    if (hasReset) {
      setHasReset(false);
    }
    handleFilterOpertation();
  }
  return (
    <Paper className="filterSearchFilter" id="filterEquipment">
      <Box>
        <SearchTopBar
          hasReset={hasReset}
          saveFilterList={saveFilterList}
          setConditions={setConditions}
          reportCode={reportCode}
          handleDelFilterSuccess={handleDelFilterSuccess}
          isShowSaveFilterDropDown={isShowSaveFilterDropDown}
        />
        {notValidCol.length === 0 ? (
          <ConditionList
            conditions={conditions}
            filterList={filterList}
            handleConditionChange={handleConditionChange}
            handleRemoveCondition={handleRemoveCondition}
            handleAddCondition={handleAddCondition}
          />
        ) : (
          <NotValidFieldColumn columnList={notValidCol} />
        )}
      </Box>
      <Box className="filterFooter">
        {showSaveButton && (
          <Button
            className="filterButton"
            variant="contained"
            color="success"
            onClick={handleSaveFilter}
            disabled={!allConditionsFilled()}
          >
            {localization.save}
          </Button>
        )}
        <Box display="flex" gap={1}>
          <Button
            className="filterButton"
            variant="contained"
            color="primary"
            onClick={toggleFilter}
          >
            {localization.cancel}
          </Button>
          <Button
            className="filterButton"
            variant="contained"
            color="primary"
            onClick={handleReset}
          >
            {localization.reset}
          </Button>
          <Button
            className="filterButton"
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={!allConditionsFilled() && !hasReset}
          >
            {localization.apply}
          </Button>
        </Box>
      </Box>
      <CopyBox
        isOpen={dialogboxOpen}
        text={messageBoxText}
        functions={msgButtons}
        close={closeMsg}
        copyAnzahl={copyAnzahl}
        //  setCopyAnzahl={setCopyAnzahl}
        handleInput={handleInput}
        placeholderName={localization.enterfiltername}
        _type="text"
      />
    </Paper>
  );
};

export default SearchBox_new;
